// Single source of truth for the sitewide footer navigation. Plain ESM so the
// Node build script (scripts/postbuild-seo.mjs) injects the SAME links into
// every pre-rendered <noscript> that Footer.tsx renders. Without this, the nav
// is React-only and the commercial/legal routes have zero crawler-visible
// inbound links (they are reachable by a non-JS crawler only via sitemap.xml).
//
// Items with `to` are crawlable links (emitted into the noscript nav and lint-
// checked as registered routes). Items with `action` are client-only controls
// (e.g. the cookie modal) and are skipped in the noscript nav.
export const FOOTER_COLUMNS = [
  {
    title: "Company",
    links: [{ label: "About EXOS", to: "/features" }],
  },
  {
    title: "Resources",
    links: [
      { label: "Methodology", to: "/methodology" },
      { label: "Blog", to: "/blog" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Terms of Service", to: "/terms" },
      { label: "AI & Analytics Disclaimer", to: "/ai-disclaimer" },
      { label: "Data Processing Addendum", to: "/dpa" },
      { label: "Cookie settings", action: "cookiePreferences" },
    ],
  },
  {
    title: "Support",
    links: [{ label: "Contact Us", to: "/pricing#contact" }],
  },
];
